export default __webpack_public_path__ + "static/media/part_logo4.687a0ed3.png";